import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row, Table } from 'react-bootstrap';
import { IconContext } from "react-icons";
import { FiPlus } from "react-icons/fi";
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import api from '../api';
import { UseTrainers } from "../contexts/TrainersContext";
import tConvert from '../utils/TConvert'
import headers from '../utils/headers'
import nowDate from '../utils/nowDate'

const Unavailable = () => {
    const [schedules, setSchedules] = useState([]);
    const [slots, setSlots] = useState([]);
    const [loading, setLoading] = useState(true);
    const { trainers } = UseTrainers();

    const getSchedules = async (id) => {
        const url = (id === 'all') ? api + '/unavailabledates?date=' + nowDate() : api + '/unavailabledates?date=' + nowDate() + '&trainer.id=' + id;
        try {
            const {data} = await axios.get(url, {headers})
            setSchedules(data);
        } catch (err) {
            console.log(err.response);
        }
    }

    const getSlots = async (id) => {
        const url = (id === 'all') ? api + '/unavailableslots?date=' + nowDate() : api + '/unavailableslots?date=' + nowDate() + '&trainer.id=' + id;
        try {
            const {data} = await axios.get(url, {headers})
            setSlots(data);
            setLoading(false);
        } catch (err) {
            console.log(err.response);
        }
    }

    useEffect(() => {
        getSchedules('all');
        getSlots('all');
    }, []);

    const onTrainerChange = (e) => {
        getSchedules(e.target.value);
        getSlots(e.target.value);
    }

    if(loading) {
        return 'Loading...';
    }

    return (
        <React.Fragment>
            <div className="container-fluid">
                <Row>
                    <Col>
                        <div className="employee-title">
                            <h3 className="dash-title">Unavailable Slots/Date</h3>
                            {(localStorage.getItem('type') === 'admin') ? (
                            <Link className="employee-add-btn" to="/unavailable/add">
                            <IconContext.Provider value={{size: '18px', color: "#fff"}}>
                                <FiPlus />
                            </IconContext.Provider>
                                Add New
                            </Link>
                            ) : ''}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="container-fluid dashboard-wrapper white-wrapper daily-activity-table">
                <Row>
                    <Form.Control as="select" style={{marginBottom: '20px'}} onChange={onTrainerChange}>
                        <option value="all">All Trainers</option>
                        {trainers.map(( trainer ) => (
                            <option value={trainer.trainer.id} key={trainer.id}>{trainer.trainer.name} #{trainer.username}</option>
                        ))}
                    </Form.Control>
                </Row>
                <Row>
                    <Table responsive hover>
                        <thead>
                            <tr>
                            <th>Name</th>
                            <th>Date</th>
                            <th>Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {schedules.map(schedule => (
                            <tr key={schedule.id}>
                                <td>
                                    <div className="wh-profile">
                                        <div className="wh-caption">
                                            <p>{schedule.trainer.name}</p>
                                        </div>
                                    </div>
                                </td>
                                <td><Moment format="Do MMMM, YYYY">{schedule.date}</Moment></td>
                                <td>Whole Day</td>
                            </tr>
                            ))}
                            {slots.map(slot => (
                            <tr key={slot.id}>
                                <td>
                                    <div className="wh-profile">
                                        <div className="wh-caption">
                                            <p>{slot.trainer.name}</p>
                                        </div>
                                    </div>
                                </td>
                                <td><Moment format="Do MMMM, YYYY">{slot.date}</Moment></td>
                                <td>{tConvert(slot.start_time)} - {tConvert(slot.end_time)}</td>
                            </tr>
                            ))}
                        </tbody>
                    </Table>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default Unavailable
